import { useLayoutEffect } from "react";

const voucherPopHandlers = new Set();

export const registerVoucherDraftPopHandler = (handler) => {
  voucherPopHandlers.add(handler);
  return () => voucherPopHandlers.delete(handler);
};

// Mount before BrowserRouter: Chrome invokes window-target popstate listeners
// in registration order even when a later listener requests capture. A listener
// installed by a reentered drawer would run after the router has unmounted it.
// This stable host is inert unless a mounted voucher draft registers a handler.
const VoucherDraftNavigationHost = () => {
  useLayoutEffect(() => {
    const onPop = (event) => {
      for (const handler of voucherPopHandlers) {
        handler(event);
        if (event.cancelBubble) break;
      }
    };
    window.addEventListener("popstate", onPop, true);
    return () => window.removeEventListener("popstate", onPop, true);
  }, []);
  return null;
};

export default VoucherDraftNavigationHost;
